export const getTableShow = store => store.tableShow
